import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link, useParams } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../Config/swal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import "../../Config/swal.css";
import { useLabelContext } from "../../../Context";

export default function EditProposal() {
    //   const { PurchaseID } = useParams();
    const { ID } = useLabelContext();
    const PurchaseID = ID;

    const [userDetails, SetUserDetails] = useState([]);
    const [subTotalAmount, setSubTotalAmount] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        const userDetailsSession = JSON.parse(
            sessionStorage.getItem("userDetails")
        );
        SetUserDetails(userDetailsSession);
    }, []);

    const [estimatePOData, setEstimatePOData] = useState({});
    const [itemsPOData, setItemsPOData] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedCustomerid, setSelectedCustomerid] = useState("");
    const [selectedprojectid, setSelectedProjectid] = useState("");
    const [selectedStatusid, setSelectedStatusid] = useState("");
    const [selectedStaffid, setSelectedStaffid] = useState("");
    const [relatedToData, setRelatedToData] = useState("")
    const [selectedRelatedToData, setSelectedRelatedToData] = useState("")
    const [selectedRelatedTo, setSelectedRelatedTo] = useState(0)
    const [customersData, setCustomersData] = useState([]);
    const [projectsData, setProjectsData] = useState([]);
    const [productsData, setProductsData] = useState([]);
    const [staffData, setStaffData] = useState([]);
    const [taxesData, setTaxesData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selecteddiscount, setselecteddiscount] = useState("");
    const [selectedTax, setSelectedTax] = useState("")
    const [discountTotal, setDiscountTotal] = useState(0);
    const [discountPercentage, setDiscountPercentage] = useState("");


    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formValues, setFormValues] = useState({
        id: PurchaseID,
        subject: "",
        content: "",
        addedfrom: "",
        datecreated: "",
        total: "",
        subtotal: "",
        total_tax: "",
        adjustment: "",
        discount_percent: "",
        discount_total: "",
        discount_type: "",
        show_quantity_as: "",
        currency: "",
        open_till: "",
        date: "",
        rel_id: "",
        rel_type: "",
        assigned: "",
        hash: "",
        proposal_to: "",
        project_id: "",
        country: "",
        zip: "",
        state: "",
        city: "",
        address: "",
        email: "",
        phone: "",
        allow_comments: "",
        status: "",
        estimate_id: "",
        invoice_id: "",
        date_converted: "",
        pipeline_order: "",
        is_expiry_notified: "",
        acceptance_firstname: "",
        acceptance_lastname: "",
        acceptance_email: "",
        acceptance_date: "",
        acceptance_ip: "",
        signature: "",
        short_link: "",
        processing: 0,
        products: [],
    });

    useEffect(() => {
        if (PurchaseID) {
            sessionStorage.setItem("purchaseId", JSON.stringify(PurchaseID));
        }

        const storedPurchaseId = sessionStorage.getItem("purchaseId");
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(
                    `${API_BASE_CRM_URL}GetProposals?id=${storedPurchaseId}`
                );
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                console.log(data)
                if (data.Status) {
                    setLoading(false);
                    setEstimatePOData(data.ResultData);
                    console.log(data);

                    setFormValues({
                        id: data.ResultData[0].proposal_id || "",
                        subject: data.ResultData[0].subject || "",
                        content: data.ResultData[0].content || "",
                        addedfrom: data.ResultData[0].addedfrom || "",
                        datecreated: formatDate(data.ResultData[0].datecreated) || "",
                        total: data.ResultData[0].total || "",
                        subtotal: data.ResultData[0].subtotal || "",
                        total_tax: data.ResultData[0].total_tax || "",
                        adjustment: data.ResultData[0].adjustment || "",
                        discount_percent: data.ResultData[0].discount_percent || "",
                        discount_total: data.ResultData[0].discount_total || "",
                        discount_type: data.ResultData[0].discount_type || "",
                        show_quantity_as: data.ResultData[0].show_quantity_as || "",
                        currency: data.ResultData[0].currency || "",
                        open_till: formatDate(data.ResultData[0].open_till) || "",
                        date: formatDate(data.ResultData[0].date) || "",
                        rel_id: data.ResultData[0].rell_id || "",
                        rel_type: data.ResultData[0].rell_type || "",
                        assigned: data.ResultData[0].assigned || "",
                        hash: data.ResultData[0].hash || "",
                        proposal_to: data.ResultData[0].proposal_to || "",
                        project_id: data.ResultData[0].project_id || "",
                        country: data.ResultData[0].country || "",
                        zip: data.ResultData[0].zip || "",
                        state: data.ResultData[0].state || "",
                        city: data.ResultData[0].city || "",
                        address: data.ResultData[0].address || "",
                        email: data.ResultData.email || "",
                        phone: data.ResultData[0].phone || "",
                        allow_comments: data.ResultData[0].allow_comments || "",
                        status: data.ResultData[0].status || "",
                        estimate_id: data.ResultData[0].estimate_id || "",
                        invoice_id: data.ResultData[0].invoice_id || "",
                        date_converted: data.ResultData[0].date_converted || "",
                        pipeline_order: data.ResultData[0].pipeline_order || "",
                        is_expiry_notified: data.ResultData[0].is_expiry_notified || "",
                        acceptance_firstname: data.ResultData[0].acceptance_firstname || "",
                        acceptance_lastname: data.ResultData[0].acceptance_lastname || "",
                        acceptance_email: data.ResultData[0].acceptance_email || "",
                        acceptance_date: data.ResultData[0].acceptance_date || "",
                        acceptance_ip: data.ResultData[0].acceptance_ip || "",
                        signature: data.ResultData[0].signature || "",
                        short_link: data.ResultData[0].short_link || "",
                        processing: 0,
                    });
                    setSelectedStaffid(data.ResultData[0].assigned)
                    setselecteddiscount(data.ResultData[0].discount_type)
                    setSelectedRelatedTo(Number(data.ResultData[0].rell_type));
                    setSelectedRelatedToData(data.ResultData[0].rell_id)
                    console.log(Number(data.ResultData[0].rell_type));

                } else {
                    setLoading(false);
                    console.error("Fetched data is not an array:", data);
                    setEstimatePOData([]);

                }
            } catch (error) {
                setLoading(false);
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [PurchaseID]);


    const handleCustomerChange = (selectedOption) => {
        setSelectedCustomerid(selectedOption);
        setFormValues((prevData) => ({
            ...prevData,
            clientid: selectedOption,
        }));
    };

    const handleProjectChange = (selectedOption) => {
        setSelectedProjectid(selectedOption);
        setFormValues((prevData) => ({
            ...prevData,
            project_id: selectedOption,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };


    const formatDate = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    //get customers
    useEffect(() => {
        const fetchData = async (url, setData) => {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Failed to fetch data from ${url}`);
                }
                const data = await response.json();
                if (data.Status) {
                    setData(data.ResultData);
                } else {
                    console.error(`Fetched data from ${url} is not an array:`, data);
                    setData([]);
                }
            } catch (error) {
                console.error(`Error fetching data from ${url}:`, error);
            }
        };

        fetchData(`${API_BASE_CRM_URL}GetCustomers`, setCustomersData);
        fetchData(`${API_BASE_CRM_URL}GetStaff`, setStaffData);
        fetchData(`${API_BASE_CRM_URL}GetTaxes`, setTaxesData);
        fetchData(`${API_BASE_CRM_URL}GetProducts`, setProductsData);
    }, []);

    //get projects by Customer ID
    useEffect(() => {
        if (selectedCustomerid) {
            const fetchData = async () => {
                try {
                    const response = await fetch(
                        `${API_BASE_CRM_URL}GetProjectsByCusId?CusID=${selectedCustomerid}`
                    );
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    if (data.Status) {
                        console.log(data.ResultData)
                        setProjectsData(data.ResultData);
                    } else {
                        console.error("Fetched data is not an array:", data);
                        setProjectsData([]);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            fetchData();
        }
    }, [selectedCustomerid]);

    const customerOptions =
        customersData &&
        customersData.map((item) => ({
            value: item.userid,
            label: item.company,
        }));

    const projectOptions =
        projectsData &&
        projectsData.map((item) => ({
            value: item.id,
            label: item.name,
        }));

    const productOptions =
        productsData &&
        productsData.map((item) => ({
            value: item.long_description,
            label: item.description,
            rate: parseFloat(item.rate),
        }));

    const staffOptions =
        staffData &&
        staffData.map((item) => ({
            value: item.staffid,
            label: item.firstname + " " + item.lastname,
        }));

    const taxOptions = taxesData && taxesData.map((item) => ({
        key: item.id,
        value: item.taxrate,
        label: item.name + " " + item.taxrate,
    }));

    const statusOptions = [
        { value: 1, label: "Draft" },
        { value: 2, label: "Sent" },
        { value: 5, label: "Expired" },
        { value: 3, label: "Declined" },
        { value: 4, label: "Accepted" },
    ];

    const relatedToOptions = [
        { value: 1, label: "Lead" },
        { value: 2, label: "Customer" },
    ];

    const discountoptions = [
        { "value": "No discount", "label": "No discount" },
        { "value": "Before tax", "label": "Before tax" },
        { "value": "After tax", "label": "After tax" },
    ]

    const handlediscountChange = (selectedone) => {
        setselecteddiscount(selectedone);
    };

    const handleSelectedRelatedToData = (selectedone) => {
        setSelectedRelatedToData(selectedone);
    };



    useEffect(() => {
        if (selectedRelatedTo === 1) {
            const fetchData = async () => {
                try {
                    const response = await fetch(`${API_BASE_CRM_URL}GetLeads`);
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    if (data.Status) {
                        setRelatedToData(data.ResultData);
                    } else {
                        console.error("Fetched data is not an array:", data);
                        setRelatedToData([]);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            fetchData();
            console.log(relatedToData.ResultData)
        } else if (selectedRelatedTo === 2) {
            const fetchData = async () => {
                try {
                    const response = await fetch(`${API_BASE_CRM_URL}GetCustomers`);
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    if (data.Status) {
                        setRelatedToData(data.ResultData);
                    } else {
                        console.error("Fetched data is not an array:", data);
                        setRelatedToData([]);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };
            fetchData();
            console.log(selectedRelatedTo.ResultData)
            console.log('Selected ID is 2');
        }
    }, [selectedRelatedTo]);

    const relatedOptions = relatedToData && relatedToData.map((item) => {
        const selectedValue = Number(selectedRelatedTo);
        console.log(selectedValue);

        if (selectedValue === 1) {
            return {
                value: item.id,
                label: item.name,
            };
        } else if (selectedValue === 2) {
            return {
                value: item.userid,
                label: item.company,
            };
        } else {
            console.log('Selected ID is out of range');
            return null;
        }
    }).filter(option => option !== null);


    useEffect(() => {
        if (formValues && formValues.status) {
            setSelectedStatusid(formValues.status);
        }
    }, [formValues]);

    const handleStatusChange = (selectedone) => {
        setSelectedStatusid(selectedone);
        setFormValues((prevData) => ({
            ...prevData,
            status: selectedone,
        }));
    };

    useEffect(() => {
        if (formValues && formValues.rel_type) {
            setSelectedRelatedTo(formValues.rel_type);
        }
    }, [formValues]);

    const handleStaffChange = (selectedone) => {
        setSelectedStaffid(selectedone);
        setFormValues((prevData) => ({
            ...prevData,
            sale_agent: selectedone,
        }));
    };

    useEffect(() => {
        console.log('selectedRelatedTo:', selectedRelatedTo);
    }, [selectedRelatedTo]);

    useEffect(() => {
        if (estimatePOData && estimatePOData.length > 0) {
            setRows(
                estimatePOData.map((item) => {
                    const rate = parseFloat(item.rate) || 0;
                    const qty = parseFloat(item.qty) || 0;
                    const weight = parseFloat(item.weight) || 0;
                    const taxPercentage = parseFloat(item.taxrate) || 9;
                    const subtotal = rate * qty;
                    const taxAmount = subtotal * (taxPercentage / 100);
                    const totalAmount = subtotal + taxAmount;

                    return {
                        id: item.id || null,
                        rel_id: item.rel_id || null,
                        description: item.description,
                        long_description: item.long_description || "",
                        qty: item.qty || "",
                        weight: item.weight || "",
                        rate: item.rate || "",
                        taxrate: item.taxrate || "",
                        amount: totalAmount,
                        item_order: item.item_order || itemsPOData.length + 1,
                    };
                })
            );
        }
    }, [estimatePOData]);

    const handleRelatedTo = (selectedone) => {
        console.log(selectedone)
        setSelectedRelatedTo(selectedone)
    }
    const addRow = (product) => {
        if (rows.some((row) => row.description === product.label)) {
            Swal.fire({
                title: "Product already added",
                text: "This product is already in the list.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        const newRow = {
            description: product.label,
            long_description: product.value || "",
            qty: 1,
            weight: "",
            rate: product.rate || 0,
            taxrate: "",
            amount: "",
            item_order: rows.length + 1,
        };

        const subtotal = parseFloat(newRow.rate) * parseFloat(newRow.qty);
        const taxAmount = subtotal * (selectedTax / 100);
        newRow.amount = (subtotal + taxAmount).toFixed(2);

        const updatedRows = [...rows, newRow];

        setRows(updatedRows);

        // Update total amount
        const updatedTotal = updatedRows.reduce(
            (sum, row) => sum + parseFloat(row.amount),
            0
        );
        setEstimatePOData((prevData) => ({
            ...prevData,
            total: updatedTotal.toFixed(2),
        }));
    };

    const handleProductChange = (value, option) => {
        setSelectedProduct(option);
        addRow(option);
    };

    const filteredOptions = selectedProduct ? [selectedProduct] : productOptions;

    const handleInputChange = (index, key, value) => {
        setRows(prevRows => {
            const updatedRows = [...prevRows];

            // Ensure valid numeric input
            const parsedValue = isNaN(parseFloat(value)) || value === "" ? 0 : parseFloat(value);
            updatedRows[index][key] = parsedValue;

            // Extract rate and quantity safely
            const rate = parseFloat(updatedRows[index].rate) || 0;
            const qty = parseFloat(updatedRows[index].qty) || 0;
            let rowSubtotal = rate * qty;

            // Find selected tax rate
            const selectedTax = taxOptions.find(option => option.value === updatedRows[index].taxrate);
            const taxPercentage = selectedTax ? parseFloat(selectedTax.percentage) || 0 : 0;

            // Calculate tax amount
            let taxAmount = rowSubtotal * (taxPercentage / 100);
            let rowAmount = rowSubtotal + taxAmount;

            // Get discount percentage from formValues safely
            const discountPercentage = parseFloat(formValues?.discount_percent) || 0;

            if (selecteddiscount === "Before tax") {
                const discount = (rowSubtotal * discountPercentage) / 100;
                rowSubtotal -= discount;
                taxAmount = rowSubtotal * (taxPercentage / 100);
                rowAmount = rowSubtotal + taxAmount;
            } else if (selecteddiscount === "After tax") {
                const discount = (rowAmount * discountPercentage) / 100;
                rowAmount -= discount;
            }

            updatedRows[index].amount = isNaN(rowAmount) ? "0.00" : rowAmount.toFixed(2);

            return updatedRows;
        });

        // Ensure totals update after rows update
        setTimeout(() => recalculateTotals(), 0);
    };

    const handleDiscountChange = (e) => {
        const discountPercent = parseFloat(e.target.value) || 0;

        setFormValues(prev => ({
            ...prev,
            discount_percent: discountPercent
        }));

        setTimeout(() => recalculateTotals(), 0);
    };

    const recalculateTotals = () => {
        setRows(prevRows => {
            let totalAmount = 0;

            prevRows.forEach(row => {
                const rowAmount = parseFloat(row.amount) || 0;
                totalAmount += rowAmount;
            });

            const discountPercentage = parseFloat(formValues?.discount_percent) || 0;
            const discountTotal = (totalAmount * discountPercentage) / 100;
            const finalAmount = totalAmount - discountTotal;

            setFormValues(prev => ({
                ...prev,
                discount_total: isNaN(discountTotal) ? "0.00" : discountTotal.toFixed(2),
                total: isNaN(finalAmount) ? "0.00" : finalAmount.toFixed(2),
            }));

            return prevRows;
        });
    };




    const handleTaxChange = (index, taxOption) => {
        setSelectedTax(taxOption);
        setRows(prevRows => {
            const updatedRows = [...prevRows];
            const updatedRow = { ...updatedRows[index], taxrate: taxOption };

            const rate = parseFloat(updatedRow.rate) || 0;
            const qty = parseFloat(updatedRow.qty) || 0;
            const taxPercentage = parseFloat(taxOption) || 0;

            const subtotal = rate * qty;
            const taxAmount = subtotal * (taxPercentage / 100);
            const totalAmount = subtotal + taxAmount;

            updatedRow.amount = totalAmount.toFixed(2);
            console.log(totalAmount)

            updatedRows[index] = updatedRow;
            return updatedRows;

        });
        setFormValues({
            ...formValues,
            total: totalAmount,
        });

    };

    // const calculateAmounts = () => {
    //     let subTotal = 0;
    //     let totalTaxAmount = 0;
    //     let totalAmount = 0;
    //     let discountTotal = 0;

    //     rows.forEach(row => {
    //         const rate = parseFloat(row.rate) || 0;
    //         const qty = parseFloat(row.qty) || 0;
    //         const rowSubtotal = rate * qty;

    //         const selectedTax = taxOptions.find(option => option.value === row.taxrate);
    //         const taxPercentage = selectedTax ? parseFloat(selectedTax.percentage) : 0;

    //         let taxAmount = rowSubtotal * (taxPercentage / 100);
    //         let rowAmount = rowSubtotal + taxAmount;

    //         if (selecteddiscount === "Before tax") {

    //             discountTotal = (rowSubtotal * discountPercentage) / 100;
    //             const discountedSubtotal = rowSubtotal - discountTotal;
    //             taxAmount = discountedSubtotal * (taxPercentage / 100);
    //             rowAmount = discountedSubtotal + taxAmount;
    //         } else if (selecteddiscount === "After tax") {

    //             discountTotal = (rowAmount * discountPercentage) / 100;
    //             rowAmount -= discountTotal;
    //         }

    //         subTotal += rowSubtotal;
    //         totalTaxAmount += taxAmount;
    //         totalAmount += rowAmount;

    //         row.amount = rowAmount.toFixed(2);
    //     });
    //     setFormValues(prev => ({
    //         ...prev,
    //         total: totalAmount.toFixed(2)
    //     }));

    //     setSubTotalAmount(subTotal.toFixed(2));
    //     setTotalAmount(totalAmount.toFixed(2));
    //     setDiscountTotal(Number(discountTotal).toFixed(2));
    //     setTotalTaxAmount(totalTaxAmount.toFixed(2));
    // };

    // useEffect(() => {
    //     calculateAmounts();
    // }, [rows, discountPercentage, selecteddiscount]);

    const handleDelete = async (index, id) => {
        if (!id) {
            console.warn("ID not found, deleting manually from UI.");
            setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));
            return;
        }

        const requestData = {
            id: id,
            rel_type: "Proposal",
            rel_id: PurchaseID,
        };

        console.log("Deleting item:", requestData);

        try {
            const response = await fetch(`${API_BASE_CRM_URL}DeleteItem`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error("Failed to delete item from backend");
            }

            setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));

            console.log(`Item with ID ${id} deleted successfully.`);
        } catch (error) {
            console.error("Error deleting item:", error);
            alert("Failed to delete the item. Please try again.");
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const updatedFormValues = {
            ...formValues,
            products: rows,
            total: estimatePOData?.total,
            // total_tax: totalTaxAmount,
            subtotal: subTotalAmount,
        };

        console.log("Data sending to API:", updatedFormValues);

        try {
            const response = await fetch(`${API_BASE_CRM_URL}EditProposal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(updatedFormValues),
            });

            const rawResponseText = await response.text();
            console.log("RAW RESPONSE TEXT:", rawResponseText);

            let result;
            try {
                result = JSON.parse(rawResponseText);
                console.log("PARSED API RESPONSE:", result);
            } catch (jsonError) {
                console.error("JSON PARSING ERROR:", jsonError);
                throw new Error("Invalid JSON response from the server.");
            }

            if (response.ok && (result?.Status === true || result?.success === true || result?.message)) {
                setLoading(false);
                Swal.fire({
                    title: "Proposal Updated Successfully.",
                    icon: "success",
                    customClass: {
                        title: "swal-title",
                        content: "swal-text",
                    },
                }).then(() => {
                    navigate("/proposal");
                });
            } else {
                throw new Error(result?.Message || "Failed to submit request.");
            }
        } catch (error) {
            setLoading(false);
            console.error("Error during submission:", error);
            Swal.fire({
                title: "Error",
                text: error.message || "Something went wrong.",
                icon: "error",
                customClass: {
                    title: "swal-title",
                    content: "swal-text",
                },
            });
        }
    };

    return (
        <Base>
            <div className="page-heade d-flex justify-content-between align-items-center mb-3">
                <div className="add-iem me-auto">
                    <div className="">
                        <h4>Edit Proposal</h4>

                    </div>

                </div>
                <div className="table-top-hea ms-auto">
                    <Link to="/proposal">
                        <button className="btn btn-primary">
                            <i className="fa-solid fa-arrow-left me-1"></i>Go to List
                        </button>
                    </Link>
                </div>
            </div>

            <div className="card table-list-card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row m-2">

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Subject</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Subject"
                                    value={formValues?.subject || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Related To</label>
                                <Select
                                    showSearch
                                    placeholder="Select type"
                                    value={selectedRelatedTo === 1 ? "Lead" : "Customer" || null}
                                    onChange={handleRelatedTo}
                                    options={relatedToOptions}
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{ height: "2.4rem" }}
                                />
                            </div>

                            {selectedRelatedTo !== 0 && (
                                <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                    <label className="form-label">
                                        {selectedRelatedTo === 1 ? "Lead" : selectedRelatedTo === 2 ? "Customer" : "Invalid"}
                                    </label>
                                    <Select
                                        showSearch
                                        placeholder="Select type"
                                        value={selectedRelatedToData || null}
                                        onChange={handleSelectedRelatedToData}
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={relatedOptions}
                                        style={{ height: "2.4rem" }}
                                    />
                                </div>
                            )}

                            {/* <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                                      <label className="form-label">Customer</label>
                                                      <Select
                                                          showSearch
                                                          placeholder="Choose customer"
                                                          value={selectedCustomerid || null}
                                                          onChange={handleCustomerChange}
                                                          filterOption={(input, option) =>
                                                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                          }
                                                          options={customerOptions}
                                                          style={{ height: '2.4rem' }}
                                                      />
                                                  </div>
                                                  <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                                      <label className="form-label">Project</label>
                                                      <Select
                                                          showSearch
                                                          placeholder="Choose project"
                                                          value={selectedprojectid || null}
                                                          onChange={handleProjectChange}
                                                          filterOption={(input, option) =>
                                                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                          }
                                                          options={projectOptions}
                                                          style={{ height: '2.4rem' }}
                                                      />
                                                  </div> */}
                            {/* <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                                      <label className="form-label"> Client PO Number</label>
                                                      <input
                                                          className="form-control"
                                                          type="text"
                                                          placeholder="Reference no"
                                                          value={referenceNo}
                                                          onChange={handleReferenceNo}
                                                      />
                                                  </div> */}

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Status</label>
                                <Select
                                    showSearch
                                    placeholder="Choose status"
                                    value={selectedStatusid || null}
                                    onChange={handleStatusChange}
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={statusOptions}
                                    style={{ height: "2.4rem" }}
                                />
                            </div>

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Discount Type</label>
                                <Select
                                    showSearch
                                    placeholder="Choose status"
                                    value={selecteddiscount || null}
                                    onChange={handlediscountChange}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={discountoptions}
                                    style={{ height: '2.4rem' }}
                                />
                            </div>

                            {/* Dates */}
                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Proposal Date</label>
                                <input
                                    type="date"
                                    name="date"
                                    className="form-control"
                                    value={formValues?.date || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Valid Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="open_till"
                                    value={formValues?.open_till || ""}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Sale Agent</label>
                                <Select
                                    showSearch
                                    placeholder="Choose agent"
                                    value={selectedStaffid || null}
                                    onChange={handleStaffChange}
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={staffOptions}
                                    style={{ height: "2.4rem" }}
                                />
                            </div>

                            {["City", "State", "Zipcode", "Email", "Phone number", "Address"].map((field) => (
                                <div key={field} className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                    <label className="form-label">{field}</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder={field}
                                        name={field.toLowerCase().replace(/\s/g, "_")}
                                        value={formValues?.[field.toLowerCase().replace(/\s/g, "_")] || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            ))}

                            <div className="d-flex flex-column col-lg-4 col-md-4 mb-2">
                                <label className="form-label">Product</label>
                                <Select
                                    showSearch
                                    placeholder="Choose product"
                                    value={selectedProduct?.value}
                                    onChange={handleProductChange}
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={filteredOptions}
                                    style={{ height: "2.4rem" }}
                                />
                            </div>
                            <div className="col-12 my-3 table-responsive" style={{ maxHeight: "20rem", overflowY: "auto" }}>
                                <table className="table table-bordered">
                                    <thead className="bg-white">
                                        <tr>
                                            <th>#</th>
                                            <th>Product</th>
                                            <th>Quantity</th>
                                            <th>Weight</th>
                                            <th>Rate</th>
                                            <th>Tax</th>
                                            <th>Amount</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Product name"
                                                        value={row.description}
                                                        readOnly
                                                    />
                                                </td>

                                                {["qty", "weight", "rate"].map((key) => (
                                                    <td key={key}>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
                                                            style={{ width: "5rem" }}
                                                            value={row[key]}
                                                            onChange={(e) => handleInputChange(index, key, e.target.value)}
                                                            onWheel={(e) => e.target.blur()}
                                                        />
                                                    </td>
                                                ))}
                                                <td>
                                                    <Select
                                                        showSearch
                                                        placeholder="Choose tax"
                                                        value={row.taxrate}
                                                        onChange={(value) => handleTaxChange(index, value)}
                                                        options={taxOptions.map(option => ({ ...option, key: option.key }))}
                                                        style={{ height: '2.4rem', width: '7rem' }}
                                                    />

                                                </td>
                                                <td>{row.amount}</td>
                                                <td>
                                                    <button className="btn" type="button" onClick={() => handleDelete(index, row.id)}>
                                                        <FontAwesomeIcon icon={faTrashCan} className="text-danger fs-6" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 my-3 text-end">
                                <label className="form-label">Discount percentage</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="discount_percent"
                                    value={formValues?.discount_percent}
                                    onChange={handleDiscountChange}>
                                </input>
                            </div>
                            <div className="col-12 my-3 text-end">
                                <h5>Subtotal Amount: {formValues?.discount_total}</h5>
                            </div>
                            <div className="col-12 my-3 text-end">
                                <h5>Discount Amount: {formValues?.discount_total}</h5>
                            </div>

                            <div className="col-12 my-3 text-end">
                                <h5>Total Amount: {formValues?.total}</h5>
                            </div>

                            <div className="d-flex flex-column col-2 m-auto mt-2">
                                <button className="btn btn-primary" type="submit">
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Base>
    );
}
